import { useState, useEffect, useRef, useMemo } from "react";
import tw from "tailwind-styled-components";
import Table from "../../Components/Properties/Recurring/RecurringTable";
import { useNavigate } from "react-router-dom";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import ViewRecurring from "../../Components/Properties/Recurring/ViewRecurring";
import { useSelector } from "react-redux";
import moment from "moment";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import NotFoundModel from "../../Components/NotFoundModel";
import { toast } from "react-toastify";
import DeleteExpense from "../../Components/Properties/Recurring/DeleteModel";
import SearchFilterBox from "../../Components/SearchFilterBox";
import EditRecurringExpense from "../../Components/Expenses/EditRecurringExpense";
import MarkAsPaidOfflineModal from "../../Components/Expenses/MarkAsPaidOfflineModal";
import SideModal from "../../Components/SideModal";
import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";
import { IoFilter } from "react-icons/io5";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import SummaryCards from "../../Components/Properties/Recurring/SummaryCard";
import FilterModal from "../../Components/Expenses/FilterModalRecurringExpense";
import MarkAsPaidOnlineModal from "../../Components/Properties/Recurring/MarkAsPaidOnlineModal";
import AutoPayEnableDisable from "../../Components/Properties/Recurring/AutoPayEnableDisable";
import { FiArrowLeft } from "react-icons/fi";

const RecurringExpenses = () => {
  const searchOptions = [
    { label: "Payable", value: 1 },
    { label: "Mobile", value: 2 },
  ];
  const [isEditExpense, setIsEditExpense] = useState(false);
  const [isEditRecurringExpense, setIsEditRecurringExpense] = useState(false);
  const [isMarkPaidExpense, setIsMarkPaidExpense] = useState(false);
  const [isViewExpense, setIsViewExpense] = useState(false);
  const [propId, setPropId] = useState("");
  const user = useSelector((state) => state.UserReducer.user);
  const [isFocused, setIsFocused] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [expenseData, setExpenseData] = useState([]);
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("UM");
  const [editUser, setEditUser] = useState(false);
  const [apiData, setApiData] = useState();
  const [filteredData, setFilteredData] = useState();
  const [summary, setSummary] = useState();
  const [summaryData, setSummaryData] = useState();

  const properties = useSelector((state) => state.PropertyReducer.property);
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );
  const [selectedProperty, setSelectedProperty] = useState(property);
  const propertyList = useSelector((state) => state.PropertyReducer.property);
  const [isDeleteExpense, setIsDeleteExpense] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [previousStartDate, setPreviousStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [previousEndDate, setPreviousEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedId, setSelectedId] = useState(null);

  const [startDate, setStartDate] = useState(previousStartDate);
  const [endDate, setEndDate] = useState(previousEndDate);

  const [filterType, setFilterType] = useState("");
  const [sideFilter, setSideFilter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [activeFilter, setActiveFilter] = useState("");
  const navigate = useNavigate();
  const apiCallTimeoutRef = useRef(null);
  const isInitialMount = useRef(true);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const btnRef = useRef(null);
  const [isOnlineMarkPaidOpen, setIsOnlineMarkPaidOpen] = useState(false);
  const [isConvertAutoPay, setIsConvertAutoPay] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);

  const initialValues = {
    name: "",
    propertyName: "",
    filterVal: filterValue,
    startDate: "",
    endDate: "",
  };

  const query = `&startDate=${startDate}&endDate=${endDate}&propId=${selectedProperty?.id}&filter=${filter}&s=${searchQuery}&t=${filterType}&typeFilter=${sideFilter}`;

  const fetchInitData = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/expense/initial-values`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    setExpenseData(response.data.data);
  };

  const categories = expenseData?.expenseCategories?.map((section) => ({
    type: "group",
    name: section.name,
    items: section.items.map((item) => ({
      value: item.id + "",
      label: item.name,
    })),
  }));

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/expense/list/web?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setApiData(res?.data);
      setFilteredData(res?.data?.list)
      setSummary(res?.data?.summary);
      fetchInitData();
      setIsFocused(true);
    }
  };

  const getError = (res) => { };

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    if (isInitialMount.current) {
      getListMutate();
      isInitialMount.current = false;
      return;
    }

    if (apiCallTimeoutRef.current) {
      clearTimeout(apiCallTimeoutRef.current);
    }

    apiCallTimeoutRef.current = setTimeout(() => {
      getListMutate();
    }, 300);

    return () => {
      if (apiCallTimeoutRef.current) {
        clearTimeout(apiCallTimeoutRef.current);
      }
    };
  }, [
    filter,
    filterValue,
    startDate,
    endDate,
    property,
    filterType,
    searchQuery,
    selectedProperty
  ]);

  useEffect(() => {
    if (apiData) {
      const groupedDues = getPayableSummary(apiData?.list);
      setSummaryData(groupedDues);
    }
  }, [apiData]);

  const getPayableSummary = (data) => {
    const summary = {
      overdue: 0,
      today: 0,
      currentMonth: 0,
      nextMonth: 0,
      future: 0,
    };

    const now = moment();
    const todayStart = now.clone().startOf("day");
    const todayEnd = now.clone().endOf("day");
    const startOfMonth = now.clone().startOf("month");
    const endOfMonth = now.clone().endOf("month");
    const nextMonthStart = now.clone().add(1, "month").startOf("month");
    const nextMonthEnd = now.clone().add(1, "month").endOf("month");

    data.forEach(item => {
      if (item.isPaid) return;

      const due = moment(item.dueDate);
      const amount = Number(item.amount || 0); // balance

      // Past → overdue (includes last to last month also)
      if (due.isBefore(startOfMonth)) {
        summary.overdue += amount;
      }

      // Today
      else if (due.isBetween(todayStart, todayEnd, null, "[]")) {
        summary.today += amount;
        summary.currentMonth += amount;
      }
      // Current month
      else if (due.isBetween(startOfMonth, endOfMonth, null, "[]")) {
        summary.currentMonth += amount;
      }

      // Next month
      else if (due.isBetween(nextMonthStart, nextMonthEnd, null, "[]")) {
        summary.nextMonth += amount;
      }

      // Anything future
      else {
        summary.future += amount;
      }
    });

    return summary;
  };

  const submitHandler = (values) => {
    //setFilter("");
    setFilterType("");
    setSearchQuery("");
    setActiveFilter("");
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    setPreviousStartDate(newValues.startDate);
    setPreviousEndDate(newValues.endDate);
    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 200);
    // return () => {
    //   clearTimeout(handler);
    // };
  };

  // const handleAddExpClose = () => {
  //   setIsShowAddExpenses(false);
  // };
  const handleEditRecurringExpClose = () => {
    setIsEditRecurringExpense(false);
  };

  const handleMarkPaidClose = () => {
    setIsMarkPaidExpense(false);
  };

  //------- Edit Recurring Expense -------
  const editRecurringExpenseFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/expense/edit/recurring`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onEditRecurringExpenseSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
      setIsEditRecurringExpense(false);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onEditRecurringExpenseError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: editRecurringExpenseLoading,
    mutate: editRecurringExpenseMutate,
  } = useMutation(editRecurringExpenseFunction, {
    onSuccess: onEditRecurringExpenseSuccess,
    onError: onEditRecurringExpenseError,
  });

  //------- Pay expense online -------
  const onlineMarkAsPaidFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/cashfree/payout/transfer/pending-expenses`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const markAsPaidSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      setIsOnlineMarkPaidOpen(false);
      toast.success(data?.data?.msg || "Success");
      getListMutate();
      //window.open(data.data.link, "_blank", "noopener,noreferrer");

    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const markAsPaidError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: onlineMarkAsPaidLoading, mutate: onlineMarkAsPaidMutate } =
    useMutation(onlineMarkAsPaidFunction, {
      onSuccess: markAsPaidSuccess,
      onError: markAsPaidError,
    });

  //------- Mark As Paid Expense -------
  const markPaidExpenseFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/expense/mark/paidx`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onMarkPaidExpenseSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
      setIsMarkPaidExpense(false);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onMarkPaidExpenseError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: markPaidExpenseLoading, mutate: markPaidExpenseMutate } =
    useMutation(markPaidExpenseFunction, {
      onSuccess: onMarkPaidExpenseSuccess,
      onError: onMarkPaidExpenseError,
    });

  const handleMarkAsPaid = (row, paymentType) => {
    setSelectedData(row);
    setIsOnlineMarkPaidOpen(false);
    setIsMarkPaidExpense(false);

    if (paymentType === "online") {
      setIsOnlineMarkPaidOpen(true);
    } else {
      setIsMarkPaidExpense(true);
    }
  }
  //------- Delete Recurring Expense -------
  const deleteRecurringExpenseFunction = async (values) => {
    // const url = `${Config.apiUrl}/expense/delete/unpaid`;
    let url
    if (filter === 'RE') {
      url = `${Config.apiUrl}/expense/delete/recurring`;
    } else {
      url = `${Config.apiUrl}/expense/delete/unpaid`;
    }
    return await axios.post(
      url,
      values,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };

  const onDeleteRecurringExpenseSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
      setIsDeleteExpense(false);
      setIsViewExpense(false);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onDeleteRecurringExpenseError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: deleteRecurringExpenseLoading,
    mutate: deleteRecurringExpenseMutate,
  } = useMutation(deleteRecurringExpenseFunction, {
    onSuccess: onDeleteRecurringExpenseSuccess,
    onError: onDeleteRecurringExpenseError,
  });

  const handleFilterChange = (values) => {
    setStartDate("");
    setEndDate("");
    //setFilter("");
    setActiveFilter("");
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
  };

  const handleClearFilters = () => {
    //setFilter("");
    setFilterType("");
    setSearchQuery("");
    setActiveFilter("");
    setStartDate(previousStartDate);
    setEndDate(previousEndDate);
  };

  const handleRecurringClick = () => {
    setPreviousStartDate(startDate);
    setPreviousEndDate(endDate);

    setStartDate("");
    setEndDate("");
    setFilter("RE");
    setFilterType("");
    setSearchQuery("");
    setActiveFilter("recurring");
  };

  const handleRemindersClick = () => {
    setPreviousStartDate(startDate);
    setPreviousEndDate(endDate);

    setStartDate("");
    setEndDate("");
    setFilter("UM");
    setFilterType("");
    setSearchQuery("");
    setActiveFilter("reminders");
    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 250);
    // return () => {
    //   clearTimeout(handler);
    // };
  };

  const getDateRangeDisplayText = () => {
    if (
      startDate &&
      endDate &&
      moment(startDate).isValid() &&
      moment(endDate).isValid()
    ) {
      return (
        moment(startDate).format("DD MMM yyyy") +
        " - " +
        moment(endDate).format("DD MMM yyyy")
      );
    }
    return "Select Date Range";
  };

  const handlePropertySelect = (property) => {
    setSelectedProperty(property);
  };

  const clearFilter = () => {
    //setSelectedId(null);
    setFilter("");
    setActiveFilter({ value: "", label: "", title: "" });
    setIsFilterOpen(false);
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  };

  const onApplyFilter = (value, label) => {
    setSideFilter(value)
    setFilterType("");
    setSearchQuery("");
    //setFilter(value);
    setActiveFilter("1");
    setIsFilterOpen(false);
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  };

  const handleFilterClose = () => {
    setSelectedCategory("");
    setActiveFilter("");
    setSideFilter("")
    setFilterType("");
    setSearchQuery("");
    //setFilter(value);
    setIsFilterOpen(false);
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  };

  const onSummaryBoxClick = (data) => {
    //setActiveFilter({ value: "", label: "", title: "" });
    setIsFilterOpen(false);
    const filteredData = filterDuesBySummary(apiData?.list, data)
    setFilteredData(filteredData);
    //setFilter(data);
  };

  const filterDuesBySummary = (dues, bucket) => {
    const now = moment();
    const today = now.clone().startOf("day");

    return dues.filter(due => {
      if (due.isPaid) return false;

      const dueDate = moment(due.dueDate);

      switch (bucket) {
        case "today":
          return dueDate.isSame(today, "day");

        case "overdue":
          return dueDate.isBefore(now.clone().startOf("month"));

        case "current":
          return dueDate.isSame(now, "month");

        case "next":
          return dueDate.isSame(now.clone().add(1, "month"), "month");

        case "future":
          return dueDate.isAfter(now.clone().add(1, "month").endOf("month"));

        default:
          return true;
      }
    });
  };

  const ConvertAutoPayFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/autopay/convert/recurring/autopay`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onConvertAutoPaySuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.message || "Success");
      setIsConvertAutoPay(false);
      setIsViewExpense(false)
      getListMutate();
    } else {
      toast.error(data?.data?.message || "An Error Occured");
    }
  };

  const onConvertAutoPayError = (data) => {
    toast.error(data?.response?.data?.message || "An Error Occured");
  };

  const { isLoading: convertAutoPayLoading, mutate: convertAutoPayMutate } =
    useMutation(ConvertAutoPayFunction, {
      onSuccess: onConvertAutoPaySuccess,
      onError: onConvertAutoPayError,
    });


  const ManualPayFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/autopay/convert/recurring/manual`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onManualPaySuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.message || "Success");
      setIsConvertAutoPay(false);
      setIsViewExpense(false)
      getListMutate();
    } else {
      toast.error(data?.data?.message || "An Error Occured");
    }
  };

  const onManualPayError = (data) => {
    toast.error(data?.response?.data?.message || "An Error Occured");
  };

  const { isLoading: manualPayLoading, mutate: manualPayMutate } =
    useMutation(ManualPayFunction, {
      onSuccess: onManualPaySuccess,
      onError: onManualPayError,
    });

  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          {filter === "RE"
            ? "Recurring Expenses"
            : "Pending Expenses"}
          <Underline />
        </BoxTitle>
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="flex items-center gap-1.5 text-primary-color text-sm
              font-medium hover:opacity-80 transition-opacity"
        >
          <FiArrowLeft size={18} />
          Back
        </button>
      </BoxHead>

      <SideModal
        isOpen={isEditRecurringExpense}
        onClose={() => setIsEditRecurringExpense(false)}
      >
        <EditRecurringExpense
          setIsEditRecurringExpense={setIsEditRecurringExpense}
          isEditRecurringExpense={isEditRecurringExpense}
          handleClose={handleEditRecurringExpClose}
          editRecurringExpenseLoading={editRecurringExpenseLoading}
          editRecurringExpenseMutate={editRecurringExpenseMutate}
          selectedData={selectedData}
          expenseData={expenseData}
          categories={categories}
          setIsDeleteExpense={setIsDeleteExpense}
          setPropId={setPropId}
          property={propertyList}
        />
      </SideModal>

      <SideModal
        isOpen={isMarkPaidExpense}
        onClose={() => setIsMarkPaidExpense(false)}
      >
        <MarkAsPaidOfflineModal
          handleClose={() => setIsMarkPaidExpense(false)}
          markPaidExpenseLoading={markPaidExpenseLoading}
          markPaidExpenseMutate={markPaidExpenseMutate}
          selectedData={selectedData}
          expenseData={expenseData}
        />
      </SideModal>

      <SideModal
        isOpen={isOnlineMarkPaidOpen && !!selectedData}
        onClose={() => setIsOnlineMarkPaidOpen(false)}
      >
        <MarkAsPaidOnlineModal
          handleClose={() => setIsOnlineMarkPaidOpen(false)}
          onlineMarkAsPaidMutate={onlineMarkAsPaidMutate}
          onlineMarkAsPaidLoading={onlineMarkAsPaidLoading}
          selectedData={selectedData}
          selectedExpense={selectedExpense}
          availableAmount={summary?.balance || summary?.payoutData?.walletBalance}
          maxTransLimit={summary?.payoutData?.maxTransLimit || 0}
        />
      </SideModal>

      <SideModal isOpen={isViewExpense} onClose={() => setIsViewExpense(false)}>
        <ViewRecurring
          setIsViewExpense={setIsViewExpense}
          selectedData={selectedData}
          setIsEditExpense={setIsEditExpense}
          setIsDeleteExpense={setIsDeleteExpense}
          setIsEditRecurringExpense={setIsEditRecurringExpense}
          setPropId={setPropId}
          filter={filter}
          setIsConvertAutoPay={setIsConvertAutoPay}
        />
      </SideModal>

      <SideModal isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)}>
        <FilterModal
          setIsFilterOpen={setIsFilterOpen}
          onApplyFilter={onApplyFilter}
          selectedData={selectedData}
          handleClose={() => setIsFilterOpen(false)}
          handleClear={handleFilterClose}
          categories={categories}
          selected={null}
          setSelectedCategory={setSelectedCategory}
          selectedCategory={selectedCategory}
        />
      </SideModal>

      {isDeleteExpense && (
        <DeleteExpense
          deleteRecurringExpenseMutate={deleteRecurringExpenseMutate}
          deleteRecurringExpenseLoading={deleteRecurringExpenseLoading}
          setIsDeleteExpense={setIsDeleteExpense}
          selectedData={selectedData}
          propId={propId}
          setIsViewExpense={setIsViewExpense}
          filter={filter}
        />
      )}


      <SideModal isOpen={isConvertAutoPay} onClose={() => setIsConvertAutoPay(false)} width="1/3" level="high">
        <AutoPayEnableDisable
          setIsConvertAutoPay={setIsConvertAutoPay}
          selectedData={selectedData}
          convertAutoPayLoading={convertAutoPayLoading}
          convertAutoPayMutate={convertAutoPayMutate}
          manualPayLoading={manualPayLoading}
          manualPayMutate={manualPayMutate}

        />
      </SideModal>
      {/* {isConvertAutoPay && (
        <AutoPayEnableDisable
          setIsConvertAutoPay={setIsConvertAutoPay}
          selectedData={selectedData}
          convertAutoPayLoading={convertAutoPayLoading}
          convertAutoPayMutate={convertAutoPayMutate}
          manualPayLoading={manualPayLoading}
          manualPayMutate={manualPayMutate}
        />
      )} */}

      <FloorTabs>
        <FloorTab
          //key="ALL"
          onClick={() => setFilter('UM')}
          $active={filter === "UM"}
        >
          Pending Expenses
        </FloorTab>
        <FloorTab
          //key="ALL"
          onClick={() => setFilter('RE')}
          $active={filter === "RE"}
        >
          Recurring Expenses
        </FloorTab>
      </FloorTabs>

      <div className="hidden md:block ml-0 text-sm text-gray-600 mb-4">
        {filter === "RE" ? (
          <>
            <strong className="text-gray-800">Recurring Expenses:</strong>{" "}
            Expenses that repeat every month, such as rent, salaries and other fixed operational costs.
          </>
        ) : (
          <>
            <strong className="text-gray-800">Pending Expenses:</strong>{" "}
            Expenses that are due or overdue and need to be paid.
          </>
        )}
      </div>

      {(isLoading || isRefetching) && !isFocused && (
        <SummarySkeletonLoading count={4} />
      )}
      {isFocused && summaryData && filter === "UM" && (
        <SummaryCards summaryData={summaryData} onClick={onSummaryBoxClick} setSelectedId={setSelectedId} selectedId={selectedId} />
      )}
      <FilterTableWrapper>
        <FilterWrapper>
          <div className="flex md:space-x-4 md:flex-row flex-col md:gap-0 gap-4">
            <SearchFilterBox
              options={searchOptions}
              handleFilterChange={handleFilterChange}
              handleClearFilters={handleClearFilters}
              className="flex-1 min-w-0"
            />
          </div>
          <div className="flex gap-4 justify-end items-center">
            <PropertiesFilterDropdown
              properties={properties}
              selectedProperty={selectedProperty}
              onPropertySelect={handlePropertySelect}
              placeholder="Select Property"
              className="min-w-[200px]"
            />

            <div className="relative">
              <FilterBtn
                ref={btnRef}
                type="button"
                title="Category Filter"
                onClick={() => setIsFilterOpen((v) => !v)}
                className={`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto}`}
              >
                <IoFilter size={14} color="#9CA3AF" />
              </FilterBtn>
              {/* Yellow dot when filter is applied */}
              {activeFilter && (
                <span className="absolute -top-1 -right-1 w-3 h-3 bg-yellow-400 rounded-full"></span>
              )}
            </div>
          </div>
        </FilterWrapper>

        {!error && !isLoading && data && (
          <TableWrapper $filter={filter}>
            <Table
              apiData={error ? [] : filteredData}
              setSelectedData={setSelectedData}
              selectedData={selectedData}
              setEditUser={setEditUser}
              setViewDetail={setViewDetail}
              userType={user.userType}
              setIsViewExpense={setIsViewExpense}
              filter={filter}
              setIsDeleteExpense={setIsDeleteExpense}
              setIsMarkPaidExpense={setIsMarkPaidExpense}
              currentPageIndex={currentPageIndex}
              setCurrentPageIndex={setCurrentPageIndex}
              handleMarkAsPaid={(row, paymentType) => handleMarkAsPaid(row, paymentType)}
              setIsConvertAutoPay={setIsConvertAutoPay}
            />
            {(error || filteredData.length === 0) && !isLoading && (
              <NotFoundModel />
            )}
          </TableWrapper>
        )}
      </FilterTableWrapper>

      {(isLoading || isRefetching) && <Loading />}
    </BoxContainer>
  );
};

const InfoPopover = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative ml-2">
      <button
        onClick={() => setOpen(v => !v)}
        aria-label="Info"
        className="w-6 h-6 rounded-full flex items-center justify-center bg-gray-100 text-gray-700 text-xs hover:bg-gray-200"
        type="button"
      >
        i
      </button>

      {open && (
        <div
          className="absolute right-0 mt-2 w-72 bg-white shadow-lg rounded-md p-3 text-sm text-gray-700 z-50"
        >
          <div className="flex justify-between items-start">
            <strong className="text-sm">What does this mean?</strong>
            <button
              onClick={() => setOpen(false)}
              className="text-gray-400 hover:text-gray-600 ml-2"
              aria-label="Close"
            >
              ✕
            </button>
          </div>

          <div className="mt-2">
            <div className="mb-2">
              <strong>Recurring Expense</strong>
              <div className="text-xs text-gray-500">
                Expenses that will occur automatically in the future on a scheduled basis.
              </div>
            </div>

            <div>
              <strong>Recurring Payable</strong>
              <div className="text-xs text-gray-500">
                Recurring expenses that have become due for payment (meaning they must be paid now).
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};



const FloorTabs = tw.div`flex overflow-x-auto bg-white rounded-md my-4 border-b`;
const FloorTab = tw.button`
  ${(p) =>
    p.$active
      ? " text-primary-color border-b-2 border-b-primary-color bg-cyan-50 "
      : " text-gray-700 "} 
   px-5 py-3  cursor-pointer font-medium transition-all duration-200 whitespace-nowrap text-sm
`;
const TableWrapper = tw.h1`
  ${(p) => (p.$filter === "UM" || p.$filter === "RE" ? "my-4" : "my-4")}
  bg-white rounded-md
`;
const FilterBtn = tw.button``;
export default RecurringExpenses;
